import { camelizeKeys } from 'humps';
import { get } from '@namespace/helpers';

export const getNotificationsInitialData = () =>
  get('/service/nc/v1/initial-data/get')
    .then(camelizeKeys)
    .then(({ status, data, errorCode }) =>
      status === 'success'
        ? Promise.resolve({
            ...data,
            notifications: data.notifications.map((item) => camelizeKeys(item))
          })
        : Promise.reject(errorCode)
    );
